/**
 * Логин поо email и пароль
 *  @param {string} email
 *  @param {string} password
 *  @returns {Promise}
 */
export const login = async (email, password) => {
  try {
    const response = await fetch("/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      let err = "Ошибка при входе. Попробуйте снова.";
      if (data.error) {
        err =
          data.error === "authentication failed"
            ? "Неверный логин или пароль"
            : data.error;
      }

      throw new Error(err);
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Метод для восстановления пароля по email
 * @param {string} email
 * @param {string} password
 * @returns {Promise}
 */
export const recover = async (email, message) => {
  try {
    const response = await fetch("/api/recover", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, message }),
    });

    if (!response.ok) {
      throw new Error("Ошибка при отправке сообщения. Попробуйте снова.");
    }

    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Переводит на экран входа и выходит из системы.
 * @returns {Promise}
 */
export const logout = async () => {
  try {
    const response = await fetch("/api/logout", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(),
    });

    if (!response.ok) {
      throw new Error("Ошибка. Попробуйте снова.");
    }

    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Проверка авторизации. Попытка получить пользователя.
 * @returns {Promise}
 */
export const getMe = async () => {
  try {
    const response = await fetch("/api/me", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error("Ошибка. Попробуйте снова.");
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Смена пароля
 * @param {string} oldPassword
 * @param {string} newPassword
 * @param {string} uuid - идентификатор пользователя
 * @returns {Promise}
 */
export const changePassword = async (oldPassword, newPassword, uuid) => {
  const body = {
    newPassword,
    ...(uuid ? { uuid } : { oldPassword }),
  };
  try {
    const response = await fetch(`/api/changepassword${uuid && "/admin"}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error("Ошибка при смене пароля. Попробуйте снова.");
    }

    return data;
  } catch (err) {
    throw err;
  }
};
